<template>
  <el-select
    ref="warehouse"
    v-model="changValue"
    placeholder="请选择仓库"
    :style="select_style ? select_style : 'width:100%;'"
    :disabled="disabled ? disabled : false"
    :clearable="true"
    @change="handleChanged"
  >
    <el-option v-for="item in options || []" :key="item.WID" :label="item.WName" :value="item.WID">
      <span class="span_label_left">{{ item.WName }}</span>
      <span class="span_label_right">{{ item.DefaultFlag ? '[默认]' : '' }}</span>
    </el-option>
  </el-select>
</template>

<script>
import { submit } from '@/api/base'
export default {
  name: 'WarehouseSelect',
  props: {
    value: {},
    select_style: null,
    disabled: null,
    set_default: null,
  },
  data() {
    return {
      options: [],
      defaultValue: null,
    }
  },
  computed: {
    changValue: {
      get() {
        var that = this
        let val = that.value
        if (typeof val == 'undefined' || val <= 0) {
          let setDefault = that.set_default ? that.set_default : false
          if (setDefault) {
            val = that.getDefaultVal()
            if (val != undefined) {
              this.$emit('update:value', val)
              this.handleChanged(val)
            }
          } else {
            val = undefined
          }
        }
        return val
      },
      set(value) {
        this.$emit('update:value', value)
      },
    },
  },
  mounted() {
    var that = this
    that.$nextTick(async () => {
      that.getWarehouses()
    })
  },
  methods: {
    async getWarehouses() {
      var that = this
      const { data } = await submit('/api/common/getWarehouseList')
      if (typeof data != 'undefined' && data.length > 0) {
        that.options = data
      }
    },
    getDefaultVal() {
      var that = this
      var val = undefined
      if (that.options.length > 0) {
        for (let i = 0; i < that.options.length; i++) {
          if (typeof that.options[i].DefaultFlag != 'undefined' && that.options[i].DefaultFlag) {
            val = that.options[i].WID
            break
          }
        }
      }
      return val
    },
    handleChanged(id) {
      var that = this
      if (that.$listeners['handleChanged']) {
        var row = null
        for (let i = 0; i < that.options.length; i++) {
          let item = that.options[i]
          let val = typeof id == 'undefined' ? 0 : id
          if (item.WID == val) {
            row = item
            break
          }
        }
        this.$emit('handleChanged', row)
      }
    },
  },
}
</script>
<style scoped>
.span_label_left {
  float: left;
}

.span_label_right {
  float: right;
  color: #8492a6;
  font-size: 13px;
  margin-left: 20px;
}
</style>
